/**
 * @cutlyft/zod-schemas — public surface.
 *
 * Validation schemas shared between the SPA (form validation) and the API
 * (controller-level input validation). Real schemas (LoginRequest, SignupRequest,
 * CreateProjectRequest, etc.) will be added after DESIGN.md (Phase 4) freezes
 * API contracts.
 */
import { z } from 'zod';

// Placeholder schema to verify Zod wiring. Remove when real schemas arrive.
export const HealthResponseSchema = z.object({
  status: z.literal('ok'),
  service: z.literal('cutlyft-api'),
  uptimeSeconds: z.number().int().min(0),
  timestamp: z.string().datetime(),
});

export type HealthResponse = z.infer<typeof HealthResponseSchema>;

// Feature schemas
export * from './auth';
export * from './tenants';
export * from './users';
export * from './combinations';
export * from './projects';
export * from './catalogue';
export * from './line-items';
export * from './optimisation';
export * from './exports';

